import { COLORS, Collapse, H3Flow } from '@monthio/react-components'
import React, { useCallback, useState } from 'react'
import KeyboardArrowUpRoundedIcon from '@material-ui/icons/KeyboardArrowUpRounded'
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const ExpandIcon = styled.div`
	display: contents;
	align-self: center;
	height: 100%;
`

export const AnswerWrapper = styled.div`
	white-space: pre-line;
	&:last-of-type {
		margin-bottom: 24px;
	}
`

export const QuestionContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: 42px;
	padding: 16px 0;
	&:not(:first-of-type) {
		border-top: 1px solid ${COLORS.GREY_SCALE.LIGHT_GREY};
	}
	cursor: pointer;
`

export const QuestionTitleContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
`

export const Title = styled(H3Flow)`
	margin: 0px;
`
export const StyledLink = styled.a`
	color: ${COLORS.PRIMARY};
	text-decoration: none;
`

interface QuestionProps {
	questionKey: string
	answerKey: string
}

export const FaqQuestion = ({ questionKey, answerKey }: QuestionProps) => {
	const [isExpanded, setExpanded] = useState(false)
	const { t } = useTranslation()

	const toggleExpanded = useCallback(() => setExpanded((prev) => !prev), [])

	return (
		<>
			<QuestionContainer onClick={toggleExpanded}>
				<QuestionTitleContainer>
					<Title>{t(questionKey)}</Title>
					<ExpandIcon>
						{isExpanded ? (
							<KeyboardArrowUpRoundedIcon />
						) : (
							<KeyboardArrowDownRoundedIcon />
						)}
					</ExpandIcon>
				</QuestionTitleContainer>
			</QuestionContainer>
			<Collapse in={isExpanded} timeout="auto">
				<AnswerWrapper>
					<Trans
						t={t}
						i18nKey={answerKey}
						components={{
							linkTag: (
								<StyledLink
									target="_blank"
									href="https://www.monthio.dk/terms"
								/>
							),
						}}
					/>
				</AnswerWrapper>
			</Collapse>
		</>
	)
}
